module.exports = __webpack_public_path__ + "img/orderTransferModel.8550e9ca.png";